import { Textarea as ChakraTextarea, TextareaProps } from '@chakra-ui/react'

export const Textarea = ({
  children,
  fontSize = 'md',
  ...props
}: TextareaProps) => {
  return (
    <ChakraTextarea
      fontSize={fontSize}
      _readOnly={{
        _focusVisible: {
          borderColor: 'border',
          outline: 'none',
        },
      }}
      {...props}
    >
      {children}
    </ChakraTextarea>
  )
}
